<script>
	import { onMount, tick } from 'svelte';
	import { userid, clientID, isProduction, sbAdmin } from './utils/utils.js';
	import List from './views/GridList.svelte';
	import Edit from './views/GridBuilder.svelte';
	export let user = null;
	export let currentUser = null;
	export let client = 'staging';
	export let currentClient = 'staging';
	export let production = false;
	let mounted = false;
	async function fetchClient() {
		mounted = false;
		await tick();
		mounted = true;
	}

	export let items = [];
	let active = 'list';
	let editId = {};
	const handleClick = (tabValue) => () => (active = tabValue);
	const editItem = (e) => {
		editId = e.detail;
		active = 'edit';
	};
	onMount(() => {
		if (user) {
			const parsedUser = JSON.parse(user);
			$clientID = client;
			// if (client == 'idshopboxai') $clientID = 'staging';
			$sbAdmin = currentUser.isShopBoxAdmin;
			$userid = parsedUser.access_token;
			$isProduction = production;
			mounted = true;
		}
	});
</script>

<svelte:head>
	<link
		rel="stylesheet"
		href="https://cdn.jsdelivr.net/npm/shepherd.js@10.0.1/dist/css/shepherd.css"
	/>
</svelte:head>
<main class="grid-builder-app">
	{#if mounted}
		{#if active == 'edit'}
			<div class="box">
				<svelte:component this={Edit} on:back={handleClick('list')} data={editId} />
			</div>
		{:else}
			<div class="box">
				<svelte:component this={List} on:editItem={editItem} {items} />
			</div>
		{/if}
	{/if}

	{#if currentUser && currentUser.isShopBoxAdmin}
		<input bind:value={$clientID} type="text" name="client" id="client" />
		<button class="primary" on:click={fetchClient}>Load client id</button>
	{/if}
</main>

<style>
	:global(*) {
		box-sizing: border-box;
		margin: 0;
	}
	:global(html, body) {
		width: 100%;
		height: 100%;
		font-family: 'Overpass', sans-serif;
	}
	:global(h1, h2) {
		font-family: 'Chivo', serif;
	}
	main {
		max-width: 1200px;
		margin: 0 auto;
		position: relative;
	}
	.box {
		margin-bottom: 1em;
	}
	:global(button) {
		background: none;
		border: none;
		cursor: pointer;
	}
	.grid-builder-app :global(button.icon) {
		padding: 0;
	}
	.grid-builder-app :global(button.primary) {
		padding: 14px 24px;
		background: #000;
		border-radius: 2px;
		border: none;
		color: #fff;
		cursor: pointer;
	}
	input {
		padding: 14px 6px;
		margin-bottom: 1em;
		border: 1px solid #727178;
		border-radius: 3px;
	}
	:global(.example-step-2, .example-step-6, .example-step-14, .example-step-15) {
		position: relative;
		z-index: 2147483647 !important;
		transform: translateX(40px);
	}
	:global(.example-step-1, .example-step-3, .example-step-11, .example-step-12, .example-step-13) {
		position: relative;
		transform: translateX(-20px);
	}
	:global(.example-step-5) {
		transform: translateY(20px);
	}
	:global(.example-step-7, .example-step-8, .example-step-9, .example-step-10) {
		transform: translateY(-20px);
	}
	:global(.shepherd-header) {
		padding: 0 0.4em !important;
	}
	:global(#tour-link) {
		text-decoration: underline !important;
	}
</style>
